import React from 'react';
import GenericCrudPage from '../../components/GenericCrudPage/GenericCrudPage';
import {softwareProductElementColumns} from './softwareProductElementColumns';
import {softwareProductElement_URL} from "../../constants/urlConfig";

const SoftwareProductElement = () => {

    return <GenericCrudPage
        title="Software Product Element"
        helptip="Administration panel for managing software product elements that can be included in licences."
        linkFetch={softwareProductElement_URL}
        deleteAction={true}
        editAction={true}
        actionsEnabled={true}
        addModal={true}
        columns={softwareProductElementColumns()}
        expandRow={true}
        link={softwareProductElement_URL}
    />;

};

export default SoftwareProductElement;